import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router'; 
 
import { CorizeBaseComponent } from '../../models/base-corize-component';
import { CorizeEnvironment } from '../../models/corize-environment';
import { BaseAuthService } from '../../services/base-auth';
import { MenuItem } from './model/menu-item';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent extends CorizeBaseComponent implements OnInit, AfterViewInit {
  @Input() items : Array<MenuItem> = new Array<MenuItem>();    
  @Output() menuClickEvent: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();
  public current: Array<MenuItem> = new Array<MenuItem>();
  public parent: Array<string> = new Array<string>(); 

  public loading = false;

  constructor( public corize:CorizeEnvironment, public router:Router  ) {
    super()
  }
  ngAfterViewInit(): void {
   
  }

  
  ngOnInit(): void {
    this.current = [...this.items]    
    this.loading = false;
  }

  loggedIn(m: MenuItem) {
    if (this.corize.loggedIn)
    {
      
    }
    if (m.loggedIn) {
      return this.corize.loggedIn;
    }

    return true;
  }

  findParent(menus : Array<MenuItem>, parent: string) {     
    var ret : Array<MenuItem>= new Array<MenuItem>();
    menus.forEach(m=>{
      if (menus.filter(d=>d.id == parent).length >0)
      {
        ret = menus; 
      }

      if (m.submenus.length >0)
      {
        m.submenus.forEach(s=>{
          if (s.id == parent)
          {
            ret = m.submenus; 
          }
          else{
            return this.findParent(s.submenus,parent)
          }
        })        
      }
    })    
    return ret;
  }

goParent()
{
  this.loading = true;

  var parent = this.parent.pop();
  var menu = this.findParent(this.items,parent);

  this.current = [...menu];
  this.loading = false;
}

menuCLick(e: MenuItem)
{
 
  if (e.submenus.length > 0) {
    this.loading = true;
    this.parent.push(e.id)
    this.current = [...e.submenus];
    this.loading = false;
    
  }
  else {
    if (e.route == "")
    {
      this.menuClickEvent.emit (e);
    }
    else{      
      this.router.navigate([e.route])
    }
  }
}
}
